import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";

export type UpdateMerchantStatusTypeRequest = {
  merchantId: number;
  processType: number;
  blackListReason?: string;
};

export type UpdateMerchantStatusTypeResponse = BaseResponse<any>;

async function updateMerchantStatusType(
  data: UpdateMerchantStatusTypeRequest
): Promise<UpdateMerchantStatusTypeResponse> {
  try {
    const response = await axiosInstance.post("/Merchant/UpdateMerchantStatusType", data);
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useUpdateMerchantStatusType() {
  return useMutation<UpdateMerchantStatusTypeResponse, Error, UpdateMerchantStatusTypeRequest>(
    (variables) => updateMerchantStatusType(variables)
  );
}